// extracted by mini-css-extract-plugin
export default {"list":"topics-management_list__pyYYY"};